export const name = "MyPlan";

export type MyPlanConstants = {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
    contentfulApiSpaceId: string;
    contentfulApiAccessToken: string;
    contentfulEnvironmentId: string;
    youtubeApiKey: string;
    nearbyResourcesApiUrl: string;
    spanishEnabled: boolean;
};

// components
export { default as Article } from "./components/Article";
export { default as Button } from "./components/Button";
export { default as CategoryIcon } from "./components/CategoryIcon";
export { default as CategoryListItem } from "./components/CategoryListItem";
export { default as CircularProgress } from "./components/CircularProgress";
export { default as DrawerButton } from "./components/DrawerButton";
export { default as Emoji } from "./components/Emoji";
export { default as ErrorBlock } from "./components/ErrorBlock";
export { default as Keypad } from "./components/Keypad";
export { default as LinearColorGraph } from "./components/LinearColorGraph";
export { default as MoodSelector } from "./components/MoodSelector";
export { default as OnboardingSlide } from "./components/OnboardingSlide";
export { default as Pip } from "./components/Pip";
export { default as QuizCta } from "./components/QuizCta";
export { default as QuizQueue } from "./components/QuizQueue";
export { default as QuizRedo } from "./components/QuizRedo";
export { default as QuizRestart } from "./components/QuizRestart";
export { default as Quote } from "./components/Quote";
export { default as Redo } from "./components/Redo";
export { default as Resource } from "./components/Resource";
export { default as Result } from "./components/Result";
export { default as SafeMode } from "./components/SafeMode";
export { default as SafeModeButton } from "./components/SafeModeButton";
export { default as SafeModeTooltip } from "./components/SafeModeTooltip";
export { default as SafetyStrategyItem } from "./components/SafetyStrategyItem";
export { default as Snippet } from "./components/Snippet";
export { default as Spinner } from "./components/Spinner";
export { default as StategiesHero } from "./components/StategiesHero";
export { default as StrategyBodyText } from "./components/StrategyBodyText";
export { default as StrategyListItem } from "./components/StrategyListItem";
export { default as Text } from "./components/Text";
export { default as MarkdownText } from "./components/MarkdownText";
export { default as richText } from "./components/RichText";

// screens
export { default as About } from "./screens/About";
export { default as Bookmarks } from "./screens/Bookmarks";
export { default as App } from "./screens/App";
export { default as Drawer } from "./screens/Drawer";
export { default as Home } from "./screens/Home";
export { default as ModalScreen } from "./screens/ModalScreen";
export { default as MyRelationship } from "./screens/MyRelationship";
export { default as MyResources } from "./screens/MyResources";
export { default as MySettings } from "./screens/MySettings";
export { default as MyStrategies } from "./screens/MyStrategies";
export { default as OnboardingFlow } from "./screens/OnboardingFlow";
export { default as PinUnlock } from "./screens/PinUnlock";
export { default as PrivacyPolicy } from "./screens/PrivacyPolicy";
export { default as Quiz } from "./screens/Quiz";
export { default as QuizIntro } from "./screens/QuizIntro";
export { default as QuizQuestion } from "./screens/QuizQuestion";
export { default as QuizReview } from "./screens/QuizReview";
export { default as ResourceCategory } from "./screens/ResourceCategory";
export { default as Root } from "./screens/Root";
export { default as SafeModeScreen } from "./screens/SafeMode";
export { default as Strategy } from "./screens/Strategy";
export { default as StrategyCategory } from "./screens/StrategyCategory";
export { default as Inactive } from "./screens/Inactive";
